import { MachineryInspectionPage } from "@dmca/frontend/widgets/admin/machinery";
import { checkPermissionsInLoader, useUser } from "@dmca/frontend/hooks";
import { createFileRoute } from "@tanstack/react-router";
import { object, optional, picklist } from "valibot";

export const Route = createFileRoute("/_authed/machinery/inspection")({
  validateSearch: object({
    type: optional(picklist(["crane", "forklift"] as const)),
  }),
  component: RouteComponent,
  loader: async ({ context }) => {
    await checkPermissionsInLoader("Machinery::ViewFeature", context);
    const { trpcQcProxy: trpc, qc } = context;
    await Promise.all([
      qc.prefetchQuery(trpc.machinery.getAll.queryOptions()),
      qc.prefetchQuery(trpc.machinery.getSignatures.queryOptions()),
    ]);
  },
  head: () => ({
    meta: [{ title: "Forklift & Crane Inspection | DNA Dashboard" }],
  }),
});

function RouteComponent() {
  const { type } = Route.useSearch();
  const navigate = Route.useNavigate();
  const user = useUser();
  return (
    <MachineryInspectionPage
      type={type}
      currentUserName={user?.name ?? ""}
      currentUserId={user?.id}
      onTypeChange={(val) => navigate({ search: { type: val } })}
    />
  );
}
